import React from 'react';

import { useCompleteModal } from 'modal.react.js';
import { FormProvider } from 'react-hook-form';

import { TYPE_OPTIONS } from './constants';
import * as scenes from './FormScenes';
import s from './index.module.css';
import { PageTypeForm } from './shared';
import * as types from './types';
import { useDetailsForm } from './useDetailsForm';

function DetailsScene({ modalData, type, initialType, isOneOffCloseModal, withoutOneOff }: types.DetailsSceneProps) {
  const { previousStep, handleDetailsSubmit, data, updateData } = modalData;
  const { detailsFormProps, setDetailsFormProps } = modalData;
  const typeOptions = TYPE_OPTIONS[type];
  const methods = useDetailsForm({ stepData: data, initialType: initialType || typeOptions[0].value });

  const updateDefaultData = () => {
    const defaultData = data?.default;
    if (defaultData) {
      const updatedPages = defaultData?.attachedPages?.map((page: any) => ({ ...page, isNew: true })); // TODO: fix type
      const updatedData = { ...defaultData, attachedPages: updatedPages };
      updateData('default', updatedData);
    }
  };
  const res = useCompleteModal();

  const handleClickOneOff = () => {
    if (isOneOffCloseModal) return res.success('one-off');

    updateDefaultData();
    previousStep();
  };

  const { watch } = methods;
  const formType = watch('type');

  React.useEffect(() => {
    setDetailsFormProps((p) => ({ ...p, type: formType }));
  }, [formType]);

  const onSubmit = async (formValues: types.FormValues) => {
    await handleDetailsSubmit(formValues);
  };

  const commonFormSceneProps = { modalData: modalData, onSubmit: onSubmit };

  const formScene = React.useMemo(() => {
    switch (formType) {
      case types.EPageType.PROPERTY:
        return <scenes.PropertyFormScene {...commonFormSceneProps} />;

      case types.EPageType.AREA:
        return <scenes.AreaFormScene {...commonFormSceneProps} />;

      case types.EPageType.ABOUT_US:
        return <scenes.AboutUsFormScene {...commonFormSceneProps} />;

      case types.EPageType.ACTIVITY:
        return <scenes.ActivityFormScene {...commonFormSceneProps} />;

      case types.EPageType.MISC:
      case types.EPageType.ABOUT_SAFARI:
      case types.EPageType.PRE_TRAVEL_INFO:
        return <scenes.CommonFormScene {...commonFormSceneProps} type={formType} />;

      default:
        return null;
    }
  }, [formType]);

  return (
    <div className={s.detailsWrapper}>
      <FormProvider {...methods}>
        <PageTypeForm
          onClickOneOff={handleClickOneOff}
          disabled={detailsFormProps.isFilled}
          options={typeOptions}
          withoutOneOff={withoutOneOff}
        />
      </FormProvider>

      <>{formScene}</>
    </div>
  );
}

export { DetailsScene };
